module.exports = __webpack_public_path__ + "static/img/amex.07bc54f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/payment-partner/amex.png
// module id = Sfou
// module chunks = 1